/**
 * @name germ
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTEgMiAuOTI1IDEuODQ4IiAvPgogIDxwYXRoIGQ9Ik0xMyAxNWguMDEiIC8+CiAgPHBhdGggZD0ibTE2IDIxLTEtMi40NzIiIC8+CiAgPHBhdGggZD0ibTE5IDItMSAxLjgwNCIgLz4KICA8cGF0aCBkPSJtMiAxOSAyLjc0Ni0xLjM3MyIgLz4KICA8cGF0aCBkPSJtMjIgMTYtMi40NzQtMi4xMyIgLz4KICA8cGF0aCBkPSJtMjIgNS0xLjgwNCAxIiAvPgogIDxwYXRoIGQ9Im0zIDEwIDIgMiIgLz4KICA8cGF0aCBkPSJNOSAxNmguMDEiIC8+CiAgPHBhdGggZD0iTTkgMjB2MiIgLz4KICA8cGF0aCBkPSJNOS4zMyA3LjAzNWMtLjUxIDEuNDc4LTEuNzg2IDIuOTMtMy4wOSAzLjc5NEE1IDUgMCAwMDkgMjBhMTIuMSAxMi4xIDAgMDAxMS45MDItOS45MTZBNiA2IDAgMDA5LjMzIDcuMDM1IiAvPgogIDxjaXJjbGUgY3g9IjE1IiBjeT0iOSIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/germ
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Germ: string = `
<svg
  class="lucide lucide-germ"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="m11 2 .925 1.848" />
  <path d="M13 15h.01" />
  <path d="m16 21-1-2.472" />
  <path d="m19 2-1 1.804" />
  <path d="m2 19 2.746-1.373" />
  <path d="m22 16-2.474-2.13" />
  <path d="m22 5-1.804 1" />
  <path d="m3 10 2 2" />
  <path d="M9 16h.01" />
  <path d="M9 20v2" />
  <path d="M9.33 7.035c-.51 1.478-1.786 2.93-3.09 3.794A5 5 0 009 20a12.1 12.1 0 0011.902-9.916A6 6 0 009.33 7.035" />
  <circle cx="15" cy="9" r="2" />
</svg>
`;

export default Germ;
